import { Area } from 'react-easy-crop';

export interface CropImageOptions {
    maxOutputSize?: number; // byte
    maxCanvasSize?: number; // px
    maxPixelRatio?: number;
    initialQuality?: number;
    minQuality?: number;
}

export async function cropAndCompressImage(
    file: File,
    crop: Area,
    options: CropImageOptions = {},
): Promise<{ blob: Blob; ext: string }> {
    const {
        maxOutputSize = 5 * 1024 * 1024,
        maxCanvasSize = 2048,
        maxPixelRatio = 2,
        initialQuality = 0.85,
        minQuality = 0.5,
    } = options;

    const image = new Image();
    image.src = URL.createObjectURL(file);
    await image.decode();

    const pixelRatio = Math.min(window.devicePixelRatio, maxPixelRatio);
    const maxSide = Math.max(crop.width, crop.height);
    const scale = Math.min(1, maxCanvasSize / maxSide);

    const canvas = document.createElement('canvas');
    canvas.width = Math.floor(crop.width * pixelRatio * scale);
    canvas.height = Math.floor(crop.height * pixelRatio * scale);

    const ctx = canvas.getContext('2d')!;
    ctx.setTransform(pixelRatio * scale, 0, 0, pixelRatio * scale, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);

    URL.revokeObjectURL(image.src);

    let quality = initialQuality;

    const toBlob = (q: number) =>
        new Promise<Blob>((resolve, reject) => {
            canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('Canvas生成失敗'))), 'image/jpeg', q);
        });

    let blob = await toBlob(quality);

    while (blob.size > maxOutputSize && quality > minQuality) {
        quality -= 0.05;
        blob = await toBlob(quality);
    }

    if (blob.size > maxOutputSize) {
        throw new Error('画像サイズが大きすぎます。トリミング範囲を小さくしてください。');
    }

    return { blob, ext: 'jpg' };
}
